module.exports = __webpack_public_path__ + "static/media/ipad-9.99c50226.jpg";